import React, { useEffect, useState } from "react";
import "./subscription.scss";
import { withRouter, Redirect, Route, NavLink } from "react-router-dom";
import store from "../../redux/store";
import { connect } from "react-redux";
import {
  getSubscribedCat,
  changeCatSubscribeStatus,
  getGroups,
  getSubscribedGroups,
  changeGroupSubscribeStatus,
} from "../../api/api";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import { isArray } from "lodash";

const options = [
  { name: "Links", code: "links", index: 1 },
  { name: "Lists", code: "lists", index: 2 },
];

const Subscription = (props) => {
  const [subs, setSubs] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [activeType, setActiveType] = React.useState(options[0]);
  const [groups, setGroups] = useState([]);
  const [subscribedGroups, setSubscribedGroups] = useState([]);

  useEffect(() => {
    (async () => {
      setLoader(true);
      getSubscribedCat()
        .then((resp) => {
          setSubs(resp.json);
          setLoader(false);
          store.dispatch({
            type: "UPDATE_SUBSCRIBED_CATEGORIES",
            payload: resp.json,
          });
        })
        .catch((err) => {
          throw err;
        });
    })();
  }, [props.randomLinkCategories]);

  useEffect(() => {
    (async () => {
      if (activeType.code === "lists") {
        setLoader(true);
        getSubscribedGroups("")
          .then((resp) => {
            setSubscribedGroups(resp.json);
            setLoader(false);
          })
          .catch((err) => {
            throw err;
          });
      }
    })();
  }, [activeType]);

  useEffect(() => {
    setLoader(true);
    if (activeType.code === "lists") {
      const controller = new AbortController();
      getGroups("", controller.signal)
        .then((res) => {
          setLoader(false);
          if (isArray(res.json)) {
            setGroups(res.json);
          }
        })
        .catch((err) => {
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, [activeType]);

  const changeSubscribeCategoriy_ = (cat) => {
    let updatedList = [...subs];
    let isBellActive = [...subs].filter((data) => {
      return data === cat.term_id;
    });
    if (isBellActive.length > 0) {
      updatedList = updatedList.filter((data, index) => {
        return data !== cat.term_id;
      });
    } else {
      updatedList.push(cat.term_id);
    }
    let query = "";
    updatedList.forEach((elem) => {
      query = query + elem + ",";
    });

    setLoader(true);
    changeCatSubscribeStatus(`category_id=${query.slice(0, -1)}`)
      .then((res) => {
        if (res.response.ok) {
          store.dispatch({
            type: "UPDATE_SUBSCRIBED_CATEGORIES",
            payload: updatedList,
          });
          setLoader(false);
          setSubs(updatedList);
        } else {
          // console.log(" failed to update ");
        }
      })
      .catch((err) => {
        throw err;
      });
  };

  const _deactivateAll = () => {
    setLoader(true);
    changeCatSubscribeStatus(`category_id=`)
      .then((resp) => {
        if (resp.response.ok) {
          store.dispatch({ type: "UPDATE_SUBSCRIBED_CATEGORIES", payload: [] });
          setLoader(false);
          setSubs([]);
        }
      })
      .catch((err) => {
        throw err;
      });
  };

  const _deactivateAllGroups = () => {
    // deactiate all groups
    setLoader(true);
    changeGroupSubscribeStatus(`group_id=`)
      .then((resp) => {
        setSubscribedGroups([]);
      })
      .catch((err) => {
        throw err;
      });
  };

  const _activateAllGroups = () => {
    //activate all groups
    let allCats = [...groups].filter((data) => {
      return data.term_id;
    });
    let finCat = allCats.filter((data) => {
      return data !== null;
    });

    let ids = [];
    finCat.forEach((d) => {
      if (d.label !== "All Groups") {
        ids.push(d.term_id);
      }
    });

    let query = "";
    ids.forEach((elem) => {
      query = query + elem + ",";
    });

    setLoader(true);
    changeGroupSubscribeStatus(`group_id=${query.slice(0, -1)}`)
      .then((resp) => {
        if (resp.response.ok) {
          setLoader(false);
          setSubscribedGroups(ids);
        }
      })
      .catch((err) => {
        throw err;
      });
  };

  const changeSubscribeGroup_ = (grp) => {
    //change subscribe group
    let updatedList = [...subscribedGroups];
    let isBellActive = [...subscribedGroups].filter((data) => {
      return data === grp.term_id;
    });
    if (isBellActive.length > 0) {
      updatedList = updatedList.filter((data, index) => {
        return data !== grp.term_id;
      });
    } else {
      updatedList.push(grp.term_id);
    }
    let query = "";
    updatedList.forEach((elem) => {
      query = query + elem + ",";
    });

    setLoader(true);
    changeGroupSubscribeStatus(`group_id=${query.slice(0, -1)}`)
      .then((res) => {
        if (res.response.ok) {
          setLoader(false);
          setSubscribedGroups(updatedList);
        } else {
          // console.log(" failed to update ");
        }
      })
      .catch((err) => {
        throw err;
      });
  };

  const _activateAll = () => {
    let allCats = [...props.categories.categories].filter((data) => {
      return data.term_id;
    });
    let finCat = allCats.filter((data) => {
      return data !== null;
    });

    let ids = [];
    finCat.forEach((d) => {
      if (d.label !== "All Categories") {
        ids.push(d.term_id);
      }
    });

    let query = "";
    ids.forEach((elem) => {
      query = query + elem + ",";
    });

    setLoader(true);
    changeCatSubscribeStatus(`category_id=${query.slice(0, -1)}`)
      .then((resp) => {
        if (resp.response.ok) {
          store.dispatch({
            type: "UPDATE_SUBSCRIBED_CATEGORIES",
            payload: ids,
          });
          setLoader(false);
          setSubs(ids);
        }
      })
      .catch((err) => {
        throw err;
      });
  };

  const _onCategoryTypeChange = (name) => {
    const activeOption = options.filter((d) => d.name === name);
    if (activeOption && activeOption[0]) {
      setActiveType(activeOption[0]);
    }
  };

  let isMobile = window.innerWidth <= 992;

  return !localStorage.getItem("userToken") ? (
    <Route>
      <Redirect to="/" />
    </Route>
  ) : (
    <>
      {loader ? (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: 1000,
            backgroundColor: "rgba(255,255,255,0)",
          }}
        ></div>
      ) : null}
      <div className="subscription-wrapper">
        <span
          className={`subscription-header ${
            props.settings.darkMode ? "page-header" : "page-header-light"
          }`}
        >
          <i class="glyph-icon flaticon-bell-1"></i>
          {props.location.pathname === "/subscription"
            ? "Email notification settings"
            : "Notification Setting"}
        </span>
        {/* <div className="cat-separator" style={{ marginTop: "5px" }}></div> */}
      </div>
      <br />
      <div
        className="subscribe-categories-wrapper"
        style={{ justifyContent: props.subsModal ? "flex-start" : "center" }}
      >
        <div
          className={
            props.settings.darkMode
              ? "subscription-categories-head-dark"
              : "subscription-categories-head"
          }
        >
          <div
            className={`subscription-categories-head${
              props.settings.darkMode ? "-dark" : ""
            }__input`}
          >
            <span>
              <i class="mail icon"></i>
              {localStorage.getItem("userEmail") || "-"}
            </span>
            <NavLink className="edit-icon" to="/account">
              <i id="edit-icon" class="edit icon"></i>
            </NavLink>
          </div>
          <div className="subscription-dropdown">
            <CustomDropdown
              handleOnClick={_onCategoryTypeChange}
              sortByValue={activeType.value}
              dropdownName={activeType.name}
              dropdownOptions={options}
            />
          </div>
        </div>
        {/* render links or groups(lists) based on active dropdown */}
        {activeType.code === "links" ? (
          <ul
            className={
              isMobile
                ? `subscribe-categories-list-mobile`
                : `subscribe-categories-list`
            }
            style={{ width: props.subsModal ? "95%" : "" }}
          >
            <li
              className={`subscribe-category ${
                props.categories.categories.length - 1 === subs.length
                  ? "subed"
                  : ""
              }`}
              onClick={() => {
                if (props.categories.categories.length - 1 === subs.length) {
                  _deactivateAll();
                } else {
                  _activateAll();
                }
              }}
            >
              <div className="image">
                <img src="data:image/png;base64,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" />
              </div>
              <div className="content">All Categories</div>
              <div className="icon">
                <i
                  style={{ fontSize: "10px", marginRight: "10px" }}
                  class={
                    props.categories.categories.length - 1 === subs.length
                      ? "glyph-icon flaticon-bell-1"
                      : "glyph-icon flaticon-bell"
                  }
                ></i>
              </div>
            </li>
            {[...props.categories.authCategories].map((data, index) => {
              let isSubed =
                subs &&
                subs.find((dataa) => {
                  return dataa === data.term_id;
                });

              let isEnd = props.categories.categories.length === index + 1;

              return data.label === "All Categories" ? null : (
                <li
                  onClick={() => changeSubscribeCategoriy_(data)}
                  key={index}
                  className={`subscribe-category ${isSubed && "subed"}`}
                  style={{ borderBottomWidth: isEnd ? "2px" : "0px" }}
                >
                  <div className="image">
                    <img src={data.icon} />
                  </div>
                  <div className="content">
                    {data.name ? data.name : "All Categories"}
                  </div>
                  <div className="icon">
                    <i
                      style={{ fontSize: "10px", marginRight: "10px" }}
                      class={
                        isSubed
                          ? "glyph-icon flaticon-bell-1"
                          : "glyph-icon flaticon-bell"
                      }
                    ></i>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <ul
            className={
              isMobile
                ? `subscribe-categories-list-mobile`
                : `subscribe-categories-list`
            }
            style={{ width: props.subsModal ? "95%" : "" }}
          >
            <li
              className={`subscribe-category ${
                groups.length === subscribedGroups.length ? "subed" : ""
              }`}
              onClick={() => {
                if (groups.length === subscribedGroups.length) {
                  _deactivateAllGroups();
                } else {
                  _activateAllGroups();
                }
              }}
            >
              <div className="image">
                <img src="data:image/png;base64,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" />
              </div>
              <div className="content">All Groups</div>
              <div className="icon">
                <i
                  style={{ fontSize: "10px", marginRight: "10px" }}
                  class={
                    groups.length === subscribedGroups.length
                      ? "glyph-icon flaticon-bell-1"
                      : "glyph-icon flaticon-bell"
                  }
                ></i>
              </div>
            </li>
            {[...groups].map((data, index) => {
              let isSubed =
                subscribedGroups &&
                subscribedGroups.find((dataa) => {
                  return dataa === data.term_id;
                });

              let isEnd = groups.length === index + 1;

              return data.label === "All Groups" ? null : (
                <li
                  onClick={() => changeSubscribeGroup_(data)}
                  key={index}
                  className={`subscribe-category ${isSubed && "subed"}`}
                  style={{ borderBottomWidth: isEnd ? "2px" : "0px" }}
                >
                  <div className="image">
                    {data.url && <img src={data.url || ""} />}
                  </div>
                  <div className="content">
                    {data.name ? data.name : "All Groups"}
                  </div>
                  <div className="icon">
                    <i
                      style={{ fontSize: "10px", marginRight: "10px" }}
                      class={
                        isSubed
                          ? "glyph-icon flaticon-bell-1"
                          : "glyph-icon flaticon-bell"
                      }
                    ></i>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    categories: state.categories,
    settings: state.settings,
  };
};

export default connect(mapStateToProps)(withRouter(Subscription));
